import { QueryClient } from 'react-query';
import { logger } from '@sentry/react';
import { ApiError } from './apiErrorClass';
import { ErrorContent, ResponseError } from './types';

export const handleApiError = async (response: Response) => {
  const json = (await response.json()) as ResponseError;
  throw new ApiError(json);
};

export const getErrorContent = (responseError: unknown): ErrorContent => {
  const errorContent: ErrorContent = {
    title: '',
    subtitle: '',
    body1: '',
    body2: ''
  };

  if (responseError instanceof ApiError) {
    errorContent.title = `${responseError?.code}.title`;
    errorContent.subtitle = `${responseError?.code}.subtitle`;
    errorContent.body1 = `${responseError?.code}.body1`;
    errorContent.body2 = `${responseError?.code}.body2`;
  }

  return errorContent;
};

export const waitUntilIdle = async (
  queryClient: QueryClient,
  timeout = 5000
): Promise<void> => {
  const start = Date.now();

  logger.info('Waiting for queries to become idle... ', {
    pendingRequests: queryClient.isFetching()
  });

  while (queryClient.isFetching() > 0 || queryClient.isMutating() > 0) {
    if (Date.now() - start > timeout) break;
    await new Promise(res => setTimeout(res, 200));
  }
};
